import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Environment from '../../services/Environment';
import Yotpo from '../../services/Yotpo';

export default function Reviews({ productInfo }) {
  useEffect(() => {
    (async () => {
      Yotpo.runScriptWhenIdIsPresent('reviewBox');
    })();
  }, []);

  return (
    <Row id='reviewBox' className='reviewBox'>
      <Col md={12} lg={12}>
        <div
          className='yotpo yotpo-main-widget'
          data-product-id={productInfo.sku || ''}
          data-price={productInfo.actualCost.toString() || ''}
          data-currency='USD'
          data-name={productInfo.name}
          data-url={`${
            Environment.getSelfDomain
          }/products/${productInfo.urlName?.toLowerCase()}`}
          data-image-url={productInfo.media[0] ? productInfo.media[0].url : ''}
        />
      </Col>
    </Row>
  );
}
